import { NationalOutlookWidget } from './nationalOutlookWidget';

const props = [
    'linkUrl',
    'poster'
];

export const NationalOutlookWidgetDirective = reactDirective => reactDirective(NationalOutlookWidget, props);
NationalOutlookWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('nationalOutlookWidget', NationalOutlookWidgetDirective);
